import { Navigate } from "react-router-dom";

export default function RedirectToRoutines() {
  return <Navigate to="/discipline-manager" replace />;
}
